import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ThirdwebProvider } from 'thirdweb/react'
import { queryClient } from './common/api-clients/client.ts'

import { ApolloProvider } from '@apollo/client'
import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev'
import swarmXClient from './common/apollo/clients/swarmx-client.ts'
import './common/i18n/index.ts'
import { RouterProvider } from 'react-router-dom'
import { appRoutes } from './routes/index.tsx'
import './index.css'

loadDevMessages()
loadErrorMessages()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThirdwebProvider>
        <ApolloProvider client={swarmXClient}>
          <RouterProvider router={appRoutes} />
        </ApolloProvider>
      </ThirdwebProvider>
    </QueryClientProvider>
  </StrictMode>
)
